import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import PricingSection from "./components/PricingSection";

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-black flex flex-col w-full">
      <Header />
      <div className="mt-[90px] flex flex-col">
        <PricingSection />
      </div>
      <div className="z-50">
        <Footer />
      </div>
    </div>
  );
};

export default PricingPage;
